import React, { Component } from "react";
import PropTypes from "prop-types";
import { Dropdown, Label } from "semantic-ui-react";

class TableFilter extends Component {
    render() {
        const {name, options, selectedValues, onDropdownSelectChange, placeHolder} = this.props;
        return (
            <div className="row">
                <div className="col-md-2">
                    <Label as='a' color='teal' pointing='right' style={{marginTop: '5px'}}>
                        {name}
                    </Label>
                </div>
                <div className="col-md-10">
                    <Dropdown placeholder={placeHolder} 
                        value={selectedValues}
                        onChange={(e, data) => onDropdownSelectChange(e, data)}
                        fluid multiple selection options={options} />
                </div>
            </div>
        );
    }
}

TableFilter.propTypes = {
    name: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    selectedValues: PropTypes.array.isRequired,
    onDropdownSelectChange: PropTypes.func.isRequired,
    placeHolder: PropTypes.string.isRequired
};

export default TableFilter;



// WEBPACK FOOTER //
// ./src/components/utils/tables/TableFilter.js